import { Component, OnInit } from '@angular/core';
import { AdminMenuService } from '../../../services/admin-menu.services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { moduloSeguridad } from '../../../diccionarios/seguridadModulo.js';
import { AdminMenu, ModeloAdminMenu, MantenerMenuGuardar } from '../../../models/adminMenu';
import { Router } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsAdminService } from '../../../utils/utilsAdmin.service';

@Component({
  selector: 'app-nivel2',
  templateUrl: './nivel2.component.html',
  styleUrls: ['./nivel2.component.css'],
})
export class Nivel2Component implements OnInit {
  formulario: FormGroup;
  diccionarioModulo: any;

  rowData;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;

  modelo: ModeloAdminMenu;
  nivel2: number = 2;
  enviarMenuSuperior: number = 2;
  descripcionMenuSuperior: string = '';

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private servicioUtils: UtilsService,
    private servicioWeb: AdminMenuService,
    private _utilsAdmin: UtilsAdminService
  ) { }

  ngOnInit() {
    this.diccionarioModulo = moduloSeguridad;

    this.enviarMenuSuperior = Number(localStorage.getItem('enviarMenuSuperior'));
    this.descripcionMenuSuperior = localStorage.getItem('descripcionMenuSuperior');

    const innclase = new AdminMenu();
    this.modelo = innclase.devolverModeloAdminMenu();

    this.getAllNivel2();
    this.componentGrid();

    this.formulario = this.fb.group({
      descripcion: ['', [Validators.required]],
      orden: ['', [Validators.required]]
    });
  } //ends Oninit

  getAllNivel2() {
    this.servicioWeb.getAllNivel(this.nivel2, this.enviarMenuSuperior).subscribe((resp: any[]) => {
      this.rowData = resp.sort((a, b) => a.orden - b.orden);
    }, (err) => {
      console.log(err);
    });
  }
  componentGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'NIVEL',
        field: this.modelo.nivelDescrip,
        sortable: true,
        resizable: true,
        filter: true,
      },
      {
        headerName: 'DESCRIPCION',
        field: this.modelo.descripcion,
        sortable: true,
        resizable: true,
        filter: true,
        width: 350,
      },
      {
        headerName: 'ORDEN',
        field: this.modelo.orden,
        sortable: true,
        resizable: true,
        filter: true,
        width: 150
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        // width: 150,
        cellRendererParams: {
          onClick: this.goNivel3.bind(this),
          label: this.diccionarioModulo.button.buttonsNombre.agregarN3,
          colorBoton: this.diccionarioModulo.button.buttonsCss.primary,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        // width: 150,
        cellRendererParams: {
          onClick: this.editarLinea.bind(this),
          label: this.diccionarioModulo.button.buttonsNombre.editar,
          colorBoton: this.diccionarioModulo.button.buttonsCss.success,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.eliminarLinea.bind(this),
          label: this.diccionarioModulo.button.buttonsNombre.eliminar,
          colorBoton: this.diccionarioModulo.button.buttonsCss.danger,
        },
      },
    ];
    this.rowSelection = 'multiple';
  } //end componentGri()

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  NuevoMenuNivel2() {
    const descripcion = this.formulario.get('descripcion').value;
    const orden = this.formulario.get('orden').value;
    this.servicioUtils.confirmarSincronoPromesaNormal({
      title: '¿Esta seguro que desea guardar un nuevo Menu Nivel 2 (' + descripcion + ')?',
      text: '',
      action: '',
      funcion: this.servicioWeb.devolverObservableOk(descripcion),
    }).then((nuevaDescripcion: any) => {
      const llenarObjeto = new MantenerMenuGuardar(null, descripcion, orden, this.nivel2, null, this.enviarMenuSuperior);
      this.guardarMenuNivel2(llenarObjeto);
    }).catch((err) => {
      console.log(err);
    });
  }

  guardarMenuNivel2(innObjeto) {
    this.servicioWeb.guardarMenu(innObjeto).subscribe((resp) => {
      this.servicioUtils.mensajeOKVisto(`Se creo el registro correctamente.`, true, 3000);
      this.formulario.get('descripcion').reset();
      this.formulario.get('orden').reset();
      this.getAllNivel2();
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  }

  // editarLinea({ rowData }) {
  //   this.servicioUtils.confirmarSincronoPromesaDetalle({
  //     title: '¿Esta seguro que desea modificar el nombre del Menu (' + rowData.descripcion + ')?',
  //     text: 'Ingrese Nuevo Nombre',
  //     action: '',
  //     funcion: this.servicioWeb.devolverObservableOk(rowData.descripcion),
  //   }).then((nuevaDescripcion: any) => {
  //     const llenarObjeto = new MantenerMenuGuardar(rowData.id, nuevaDescripcion, this.nivel2, null, this.enviarMenuSuperior);
  //     this.actualizarMenuNivel2(llenarObjeto);
  //   }).catch((err) => {
  //     console.log(err);
  //   });
  // }

  editarLinea({ rowData }) {
    const data = { descripcion: rowData.descripcion, orden: rowData.orden };
    this._utilsAdmin.confirmarSincronoPromesaMenu({
      title: '¿Está seguro que desea modificar el Menú (' + rowData.descripcion + ')?',
      action: '',
      funcion: this.servicioWeb.devolverObservableOk(data),
      data: data
    }).then((obj: any) => {
      console.log(obj);
      // const llenarObjeto = new MantenerMenuGuardar(rowData.id, obj.descripcion, obj.orden);
      const llenarObjeto = new MantenerMenuGuardar(rowData.id, obj.descripcion, obj.orden, this.nivel2, null, this.enviarMenuSuperior);
      this.actualizarMenuNivel2(llenarObjeto);
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizarMenuNivel2(innObjeto) {
    this.servicioWeb.actualizarMenu(innObjeto).subscribe((resp) => {
      this.getAllNivel2();
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  } //

  eliminarMenuNivel1(innId) {
    this.servicioWeb.eliminarId(innId).subscribe((resp) => {
      // this.getAllNivel2();
      this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
    }, (error) => {
      this.servicioUtils.mensajeErrorVisto(error.error.mensaje, true, 3000);
    });
  } //

  eliminarLinea({ rowData }) {
    this.servicioUtils.confirmarSincronoPromesaNormal({
      title: '¿Esta seguro que desea Eliminar un nuevo Menu Nivel 1 (' + rowData.descripcion + ')?',
      text: '',
      action: '',
      funcion: this.servicioWeb.devolverObservableOk(rowData.descripcion),
    }).then((nuevaDescripcion: any) => {
      this.eliminarMenuNivel1(rowData.id);
    }).catch((err) => {
      console.log(err);
    });
  }

  goNivel3({ rowData }) {
    localStorage.setItem('descripcionMenuSuperiorNivel2', rowData.descripcion);
    localStorage.setItem('enviarMenuSuperiorNivel2', rowData.id);
    //localStorage.setItem('enviarDescripcionNivel3', rowData.id);
    this.router.navigate(['admin-seguridad/mantener-menu/3']);
  } //

  goNivel1() {
    this.router.navigate(['admin-seguridad/mantener-menu/']);
  }
} //end class
